/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import ActionGet from '../../store/action/Ticket/Fetch'
import ActionGetDetail from '../../store/action/Ticket/FetchDetailTicket'
import ActionGetAllClient from '../../store/action/Client/FetchAll'
import ActionGetAllDivision from '../../store/action/Division/FetchAll'
import ActionGetAllSender from '../../store/action/Sender/FetchAll'
import ActionGetAllCategory from '../../store/action/Category/FetchAll'
import ActionGetAllPriority from '../../store/action/Priority/FetchAll'
import ActionGetAllCs from '../../store/action/HelpdeskCs/FetchAll'
import ActionGetAllSpv from '../../store/action/Supervisor/FetchAll'
import CustomGridSearch from '../../infra/components/grid/custom-grid-without-search'
import './Overview.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import {GetCategoryAll} from "../../store/constants";
import {ClientId, DivisionId, PrevilageId} from "../../helper/HelperAuth";
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import DatePickerInput from "../../infra/components/formInput/DatePickerInput";
import ActionFindByGroupId from '../../store/action/Previlage/FindByGroupId'

class Page extends Component{
    constructor(props){
        super(props)
        this.state = {
            title: "Ticket History",
            isadmin:false,
            modal: false,
            selectedRow: fromJS({}),
            formSearch: fromJS({
                "search": ""
            }),
            search: fromJS([
                { widthClass:'col-sm-12',id: 'search', placeholder: 'Search', label : '', value:'' },
            ]),
            searchForm : fromJS({
                "spv-id"        : 0,
                "cs-id"         : 0,
                "category-id"   : '',
                "priority-id"   : '',
                "start-date"    : '',
                "end-date"      : '',
                'client-id'     : '',
                'division-id'   : '',
                'sender-id'     : ''
            }),
            columns:[
                { className : "col-sm-1", cfield: "counter", caption: "No" },
                { className : "col-sm-2", field: "msisdn", caption: "MSISDN", allowSearch: true },
                { className : "", field: "ticket-no", caption: "Ticket No", allowSearch: true },
                { className : "col-sm-2", field: "request-date", caption: "Request Date", allowSearch: true },
                { className : "col-sm-2", field: "closed-date", caption: "Closed Date", allowSearch: true },
                { className : "col-sm-1", cfield: "action", caption: "Actions", allowView: true, allowEdit : false, allowDelete : false, allowNew: false }    
            ],
            errors: fromJS({})
        };
    
        this.showContent = this.showContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleFind = this.handleFind.bind(this);
        this.handleViewClicked = this.handleViewClicked.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.renderModalBody = this.renderModalBody.bind(this)
    }

    async componentDidMount(){
        var isAdmin = await this.props.actionFindByGroupId();
        this.setState({isadmin:isAdmin})
        this.props.actionGetAllClient()
        this.props.actionGetAllSpv()
    }

    handleSearch(obj){
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }

    handleCancelForm(refresh){
        if(refresh){
            this.handleFindSearch(1);
        }
        this.setState({ 
            form:  fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleViewClicked = (value) => {
        this.props.actionGetDetail(value.get('ticket-no'))
        this.setState({ 
            modal : true,
            selectedRow: value
        })
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }

    handleChange(field, value, label) {
        var formVal = this.state.searchForm;
        formVal = formVal.set(field,value);
        let client_id = ClientId;
        let res = null;
        let sender = [""];
        var bodyCatrgory = {};
        var bodyPriority = {};

        if(field === 'client-id'){

            formVal = formVal.set('sender-id','')
            formVal = formVal.set('division-id','')
            formVal = formVal.set('category-id','')
            formVal = formVal.set('priority-id','')

            this.setState({ searchForm:formVal })
            this.setState({client_id: value})

            this.setState({client_id: value})
            this.props.actionGetAllDivision(value);
            this.props.actionGetAllSender(value);
            client_id = value;

            setTimeout(() => {
                res = this.props.senderall;

                if (res.size > 0) sender = [];
                {res.map((data, i) =>
                    sender.push(data.get('sender-id'))
                )}

                bodyCatrgory = {
                    "sender-id" : sender,
                    "category-name": "",
                }

                bodyPriority = {
                    "sender-id" : sender,
                    "priority-name": "",
                }

                this.props.actionGetAllCategory(bodyCatrgory)
                this.props.actionGetAllPriority(bodyPriority)
            }, 3000);
        }

        if (field == 'division-id') {
            formVal = formVal.set('sender-id','')
            this.setState({ searchForm:formVal })
            this.props.actionGetAllSender(client_id, value);
            setTimeout(() => {
                res = this.props.senderall;

                if (res.size > 0) sender = [];
                {res.map((data, i) =>
                    sender.push(data.get('sender-id'))
                )}

                bodyCatrgory = {
                    "sender-id" : sender,
                    "category-name": "",
                }

                bodyPriority = {
                    "sender-id" : sender,
                    "priority-name": "",
                }

                this.props.actionGetAllCategory(bodyCatrgory)
                this.props.actionGetAllPriority(bodyPriority)
            }, 3000);
        }

        if (field == 'sender-id') {
            bodyCatrgory = {
                "sender-id" : [value],
                "category-name": "",
            }

            bodyPriority = {
                "sender-id" : [value],
                "priority-name": "",
            }

            this.props.actionGetAllCategory(bodyCatrgory)
            this.props.actionGetAllPriority(bodyPriority)
        }


        if (field == 'spv-id') {
            if (value != null) {
                this.props.actionGetAllCs(value);
            }
        }


        this.setState({ searchForm:formVal })

        if(field == 'start-date'){
            let formEndDate = formVal.set('end-date', value)
            this.setState({searchForm:formEndDate})
        }

    }

    refreshGrid(page, search){
        this.handleFindSearch(page);
    }

    handleFind(){
        this.handleFindSearch(1);
    }

    handleFindSearch(page){
        const {searchForm} = this.state;
        let spv_id          = searchForm.get('spv-id');
        let cs_id           = searchForm.get('cs-id');
        let category_id     = searchForm.get('category-id');
        let priority_id     = searchForm.get('priority-id');
        let client_id       = searchForm.get('client-id');
        let division_id     = searchForm.get('division-id');
        let sender_id       = searchForm.get('sender-id');
        let start_date      = searchForm.get('start-date');
        let end_date        = searchForm.get('end-date');

        let res = null;
        let sender = [""];
        var bodyFInd = {};
        var isAdmin = this.state.isadmin

        if (PrevilageId != 1 && isAdmin == false && client_id == "") client_id = ClientId;
        if (PrevilageId != 1 && isAdmin == false && division_id == "") division_id = DivisionId;

        category_id = category_id == '' ? 0 : category_id;
        priority_id = priority_id == '' ? 0 : priority_id;

        this.props.actionGetAllSender(client_id, division_id)
        setTimeout(() => {
            res = this.props.senderall;

            if (res.size > 0 ) sender = [];

            {res.map((data, i) =>
                sender.push(data.get('sender-id'))
            )}

            if (sender_id != "" ) sender = [sender_id]
            if (sender.length == 1 && sender[0] == null) {
                setTimeout(() => {
                    res = this.props.senderall;
                    if (res.size > 0) sender.shift();
                    {res.map((dataSender, i) =>
                        sender.push(dataSender.get('sender-id'))
                    )}
                    if(res.size == 0) sender = [""]
                    bodyFInd = {
                        "spv-id"        : spv_id,
                        "cs-id"         : cs_id,
                        "category-id"   : category_id,
                        "priority-id"   : priority_id,
                        "date-start"    : start_date,
                        "date-end"      : end_date,
                        'client-id'     : client_id,
                        'division-id'   : division_id,
                        "sender-id"     : sender
                    }

                    this.props.actionGet(page,this.state.sortForm, bodyFInd);
                }, 1500);
            } else {
                bodyFInd = {
                    "spv-id"        : spv_id,
                    "cs-id"         : cs_id,
                    "category-id"   : category_id,
                    "priority-id"   : priority_id,
                    "date-start"    : start_date,
                    "date-end"      : end_date,
                    'client-id'     : client_id,
                    'division-id'   : division_id,
                    "sender-id"     : sender
                }

                this.props.actionGet(page,this.state.sortForm, bodyFInd);
            }
        }, 3000);
    }

    showContent(){
        const {title} = this.state;
    
        const items = this.props.tickethistory ? fromJS(this.props.tickethistory) : fromJS({});

        return (
            <CustomGridSearch 
                title={ title }
                columns={ this.state.columns  } 
                items={ items }  
                search={ this.state.search }
                handleSearch={ this.handleSearch }
                handleViewClicked={this.handleViewClicked}
                handlePageChanged={this.handlePageChanged}
            >
            </CustomGridSearch>
        )
    }

    handleCloseModal(){
        this.setState({ modal : false })
    }

    render(){
        const { modal, searchForm, errors} = this.state

        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                    { this.state.title }
                    </h4>
                </div>
                <div className='card'>
                    <div className="body">
                        <div className="row">
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='client-id'
                                    value={searchForm.get('client-id')}
                                    options={fromJS({
                                        'source': this.props.clientall,
                                        'value': 'client-id',
                                        'label': 'client-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Client"
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='division-id'
                                    value={searchForm.get('division-id')}
                                    options={fromJS({
                                        'source': this.props.divisionall,
                                        'value': 'division-id',
                                        'label': 'division-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Division"
                                    disabled={this.state.disabled}
                                    hasError={errors.has('division-id')}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='sender-id'
                                    value={searchForm.get('sender-id')}
                                    options={fromJS({
                                        'source': this.props.senderall,
                                        'value': 'sender-id',
                                        'label': 'sender-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Sender"
                                    disabled={this.state.disabled}
                                    hasError={errors.has('sender-id')}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='category-id'
                                    value={searchForm.get('category-id')}
                                    options={fromJS({
                                        'source': this.props.categoryAll,
                                        'value': 'category-id',
                                        'label': 'category-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Category"
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='priority-id'
                                    value={searchForm.get('priority-id')}
                                    options={fromJS({
                                        'source': this.props.priorityAll,
                                        'value': 'priority-id',
                                        'label': 'priority-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Priority"
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='spv-id'
                                    value={searchForm.get('spv-id')}
                                    options={fromJS({
                                        'source': this.props.supervisorsall,
                                        'value': 'spv-id',
                                        'label': 'spv-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Supervisor"
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='cs-id'
                                    value={searchForm.get('cs-id')}
                                    options={fromJS({
                                        'source': this.props.helpdeskcsAll,
                                        'value': 'cs-id',
                                        'label': 'cs-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Customer Service"
                                />
                            </div>
                            <span className="col-sm-1">Start</span>
                            <div className="col-sm-2">
                                <DatePickerInput
                                    dateFormat="yyyy-MM-dd"
                                    convertvalue
                                    field="start-date"
                                    value={ searchForm.get('start-date') }
                                    onChange={(field, date) => this.handleChange(field, date)}
                                />
                            </div>
                            <span className="col-sm-1">End</span>
                            <div className="col-sm-2">
                                <DatePickerInput
                                    convertvalue
                                    dateFormat="yyyy-MM-dd"
                                    field="end-date"
                                    value={ searchForm.get('end-date') }
                                    onChange={(field, date) => this.handleChange(field, date)}
                                    minDate={new Date(searchForm.get('start-date'))}
                                />
                            </div>
                        </div>
                        <div className="row no-margin-bottom" >
                            <div className="col-sm-12">
                                <button type="button"
                                        className="btn btn-wide btn-success"
                                        onClick={this.handleFind}>
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    this.showContent()
                }
                 <Modal isOpen={modal} toggle={() => { }} fade={false} >
                    <ModalHeader>
                        Detail
                        <button  className={ `btn-close bg-red pull-right` } onClick={() => this.handleCloseModal() } >
                        <i class="material-icons">clear</i>
                            </button>
                    </ModalHeader>
                    <ModalBody>
                        {this.renderModalBody()}
                    </ModalBody>
                </Modal>
            </div>
        );
    }

    renderModalBody(){
        const { modal } = this.state
        const { detailticket } = this.props
        if(modal){
            return (
                detailticket.map((item) => {
                    return this.renderMsg(item)
                })
            )
        }
    }



    renderMsg(buble){
        var data = buble.get('data')
        var caption = data.get('caption')
        var lat = data.get('latitude')
        var media = data.get('media-url')

        if (lat !== '') {
            lat = <div><a href={"https://www.google.com/maps?q=loc:" + data.get('latitude') + "," + data.get('longitude')} target="_blank">
                <i className="material-icons">location_on</i>
            </a>
                <span>
                    {data.get('latitude') + "," + data.get('longitude')}
                </span>
            </div>
        }
        if (media !== '') {
            media = <div>
                <a href={data.get('media-url')} target="_blank">
                    <i className="material-icons">attach_file</i>
                </a>
            </div>
        }
        //debugger;
        if(buble.get('bubble_type') === 'inbound'){
            return (
                <div className="d-flex justify-content-start mb-4">
                    <div className="img_cont_msg">
                        <i className="material-icons">person</i>
                    </div>
                    <div className="msg_cotainer">
                        {media}
                        {lat}
                        {caption}
                        <span className="msg_time">{buble.get('bubble-date')}</span>
                    </div>
                </div>
            )
        }else if(buble.get('bubble_type') === 'outbond'){
            return(
                <div className="d-flex justify-content-end mb-4">
                    <div className="msg_cotainer_send">
                        {media}
                        {lat}
                        {caption}

                        <span className="msg_time_send">{buble.get('bubble-date')}</span>
                    </div>
                    <div className="img_cont_msg">
                        <i className="material-icons">person</i>
                    </div>
                </div>
            )
        }
    }
}


export default connect(
  (state) => {
      return {
          tickethistory : state.user.tickethistory,
          detailticket  : state.user.detailticket,
          helpdeskcsAll : state.user.helpdeskcsAll,
          priorityAll   : state.user.priorityAll,
          categoryAll   : state.user.categoryAll,
          clientall     : state.user.clientall,
          senderall     : state.user.senders,
          divisionall   : state.user.divisionall,
          supervisorsall    : state.user.supervisorsall,
      }
  },
  dispatch => bindActionCreators({
      actionGet: ActionGet,
      actionGetAllClient: ActionGetAllClient,
      actionGetAllDivision: ActionGetAllDivision,
      actionGetAllSender: ActionGetAllSender,
      actionGetAllCategory: ActionGetAllCategory,
      actionGetAllPriority: ActionGetAllPriority,
      actionFindByGroupId:ActionFindByGroupId,
      actionGetAllCs: ActionGetAllCs,
      actionGetAllSpv: ActionGetAllSpv,
      actionGetDetail: ActionGetDetail, 
  }, dispatch),
)(Page);